import React from 'react'
// Styles
import styles from './BackgroundImg.module.scss'

function BackgroundImg() {
    return (
        <svg
            className={styles.backgroundImg}
            width="1608px"
            height="341px"
            viewBox="0 0 1608 341"
            version="1.1"
        >
            <defs>
                <path
                    d="M1124.45587,0.00639317481 C1020.21128,198.697563 813.728832,335.331502 574.904969,340.011755 L549.551065,340.011755 C310.727201,335.331502 104.244751,198.697563 0.000167673029,0.00639317481 L1124.45587,0.00639317481 Z"
                    id="path-1"
                ></path>
            </defs>
            <g
                id="Desktop-Home"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g id="Health" transform="translate(-245.000000, 0.000000)">
                    <g id="circles" transform="translate(245.835948, 0.002591)">
                        <path
                            d="M1607.01507,-0.000837744452 C1523.77691,69.298343 1416.7361,110.98144 1299.95968,110.98144 C1183.18325,110.98144 1076.14243,69.2983324 992.904262,-0.000837744452 L1607.01507,-0.000837744452 Z"
                            id="Path"
                            fill="var(--background-img-bg)"
                            opacity="0.08"
                        ></path>
                        <g id="Path" opacity="0.05">
                            <use fill="#FFFFFF" href="#path-1"></use>
                            <use
                                fill="var(--background-img-bg)"
                                href="#path-1"
                            ></use>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}

export default BackgroundImg
